import { axiosInstance } from './axiosInstance';

export const FCMService = {
  get: async () => {
    return await axiosInstance.get(`/api/config/history-push-notification`);
  },
  create: async (data) => {
    return await axiosInstance.post('/api/feature/user/fcm-topic/send', data);
  },
  send: async (data) => {
    return await axiosInstance.post('/api/feature/user/fcm-token/send', data);
  }
}